import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faBars,
  faCalendar,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faCode,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEnvelope,
  faFile,
  faFileCode,
  faFolder,
  faFolderOpen,
  faHome,
  faImage,
  faLink,
  faPlus,
  faPuzzlePiece,
  faTimes,
  faTrash,
  faUndo,
  faUser,
  faUserCircle,
  faLanguage,
  faEnvelopeSquare,
  faServer,
  faSwatchbook,
  faSwimmingPool,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons'

/* Use when design requires regular icons */
import {
  faWalkieTalkie
} from '@fortawesome/pro-regular-svg-icons'

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faBars,
  faCalendar,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faCode,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEnvelope,
  faTimesCircle,
  faFile,
  faFileCode,
  faFolder,
  faFolderOpen,
  faHome,
  faImage,
  faLink,
  faPlus,
  faPuzzlePiece,
  faTimes,
  faTrash,
  faUndo,
  faUser,
  faUserCircle,
  faLanguage,
  faEnvelopeSquare,
  faServer,
  faSwatchbook,
  faSwimmingPool,
  faChartLine,
  faWalkieTalkie
)

// Set the FontAwesome icon set
Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/fontawesome.js